import React, {Fragment} from 'react';

const Actions = (props) => <Fragment {...props} />;

export default Actions;
